<script setup async lang="ts">
import {computed, ref} from "vue";
import {getting} from "@/Composables/api";
import {PageLoading} from "@/Components/Global";
import {Button} from "@/Components/Library";
import {useRouter} from "vue-router";
import ManageGroupMemberItem from "../Groups/ManageGroupMemberItem.vue";

const model = defineModel({default: []});
const props = withDefaults(defineProps<{contacts: any}>(), {contacts: []});
const emit = defineEmits(["save"]);
const changed = ref(false);
const router = useRouter();
const selectedContacts = computed(() =>
    props.contacts
        .filter((contact: any) => model.value.includes(contact.id))
        .sort((a: any, b: any) => a.last_name.localeCompare(b.last_name)),
);
const unselectedContacts = computed(() =>
    props.contacts
        .filter((contact: any) => !model.value.includes(contact.id))
        .sort((a: any, b: any) => a.last_name.localeCompare(b.last_name)),
);
const selectContact = (contact: any) => {
    console.log(contact);
    if (model.value.includes(contact.id)) {
        model.value.splice(model.value.indexOf(contact.id), 1);
    } else {
        model.value.push(contact.id);
    }
    changed.value = true;
};

const selectAll = () => {
    model.value = props.contacts.map((contact: any) => contact.id);
    changed.value = true;
};

const deselectAll = () => {
    model.value = [];
    changed.value = true;
};
</script>
<template>
    <div>
        <PageLoading v-if="getting.includes('contacts')" />
        <div class="flex flex-col gap-6 xl:flex-row">
            <div class="w-full xl:w-1/2">
                <div>
                    <div class="mb-2 flex items-center">
                        <div>
                            <h3 class="font-bold">Group members</h3>
                            <p class="text-xs">
                                Tap a group member to remove them. Once you have set your group hit the save button.
                            </p>
                        </div>
                        <Button
                            @click="deselectAll"
                            class="ml-auto h-8 w-8 flex-none text-red-600"
                            :icon="{icon: 'simple-line-icons:minus', width: 20}"
                        />
                    </div>
                    <div v-if="selectedContacts.length" class="mb-4 grid grid-cols-2 gap-1" v-auto-animate>
                        <template v-for="contact in selectedContacts" :key="contact.id">
                            <ManageGroupMemberItem :contact="contact" @select="selectContact" />
                        </template>
                    </div>
                    <template v-else>
                        <div class="mb-3 w-full py-6 text-center text-stone-500">
                            You have not selected any contacts
                        </div>
                    </template>
                </div>
                <div class="flex w-full flex-col items-center">
                    <Button
                        @click="emit('save')"
                        class="w-full"
                        :class="[
                            changed
                                ? 'bg-askr-green text-white'
                                : 'bg-stone-200 text-stone-400 dark:bg-stone-900 dark:text-stone-600',
                        ]"
                    >
                        Save selection
                    </Button>
                    <Button @click="router.back()" class="text-sm font-medium">Cancel</Button>
                </div>
            </div>
            <div class="w-full xl:w-1/2">
                <div class="mb-2 flex">
                    <div>
                        <h3 class="font-bold">Select contacts</h3>
                        <p class="text-xs">
                            Tap a contact to add them to your group. When you have selected your group hit the save
                            button.
                        </p>
                    </div>
                    <Button
                        @click="selectAll"
                        class="ml-auto h-8 w-8 flex-none text-askr-green"
                        :icon="{icon: 'material-symbols:select-all', width: 24}"
                    />
                </div>
                <div v-if="unselectedContacts.length" class="grid grid-cols-2 gap-1" v-auto-animate>
                    <template v-for="contact in unselectedContacts" :key="contact.id">
                        <ManageGroupMemberItem :contact="contact" @select="selectContact" />
                    </template>
                </div>
                <div class="mb-4 mt-4 w-full text-center text-stone-500">
                    <p v-if="!unselectedContacts.length" class="py-3">No more contacts available</p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
